import React from 'react';

export default ({person, selected, onClick}) => {
    let {userName, id} = person;
    let className = selected ? "person selected" : "person";
    return (
        <div
          onClick={onClick}
          className={className}>
          <div className="name">
            {userName || id}
          </div>
        </div>
    );
};
